module.exports = "/images/logo-green-dark-beta.svg?1f741569ba0e335e9d1d8cd2ab2c3d41";